<div class="json-toolbar">
  <app-guid-picker-button [baseTable]="baseTable" [fieldHint]="fieldHint"></app-guid-picker-button>
  <button
    mat-icon-button
    type="button"
    class="expand-button"
    [disabled]="disabled"
    [matTooltip]="readOnly ? 'Open expanded JSON viewer' : 'Open expanded JSON editor'"
    (click)="openExpandedEditor()"
  >
    <mat-icon>open_in_full</mat-icon>
  </button>
</div>
<json-editor [options]="editorOptions()" (change)="handleChange($event)" [data]="initialValue || {}"></json-editor>
